import { AppState } from '../../../store/store'

export const selectFlags = (state: AppState) => state.flagReducer.flags
